module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Socket-us-8622fddf87b1c5263769498aec69cf37.svg";